import React from "react";
import PropTypes from "prop-types";
import RadioButtonGroup from "../../elements/radio-button-group";
import "./style.scss";
import Heading from "../../elements/heading";

const DeliveryOptions = ({ heading, freeText, options, selectedOption, onChange, isDisabled, orderFetched, isFree }) => {
  const optionLayout = option => (
    <div className="option">
      <div className="option__row">
        {/*<img className="option__logo" src={option.logo} />*/}
        <div className="option__info">
          <div>
            <p className="option__label">{option.label}</p>
            <p className="option__time">{option.deliveryTime}</p>
          </div>
          {orderFetched && (
            <div>
              <p className="option__price">{isFree ? freeText || "Free" : option.formattedPrice}</p>
            </div>
          )}
        </div>
      </div>
      {option.note && <p className="option__note">{option.note}</p>}
    </div>
  );

  return (
    <div className="delivery-options">
      <Heading type={{ fields: { phrase: { value: "h3" } } }} className="delivery-options__heading" html={heading} />
      <RadioButtonGroup options={options} selectedOption={selectedOption} html={optionLayout} alignment="top" onChange={onChange} isDisabled={isDisabled} />
    </div>
  );
};

DeliveryOptions.propTypes = {
  heading: PropTypes.string.isRequired,
  selectedOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      logo: PropTypes.string,
      deliveryTime: PropTypes.string,
      formattedPrice: PropTypes.string,
      note: PropTypes.string
    })
  ),
  onChange: PropTypes.func.isRequired
};

DeliveryOptions.defaultProps = {
  selectedOption: null,
  options: []
};

export default DeliveryOptions;
